module.exports = __webpack_public_path__ + "img/box.5e2fc305.svg";